import React from 'react';
import noop from 'lodash/noop';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import {
	ContextualAnalyticsData as ContextualAnalyticsDataDI,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import AsyncHardDeleteProjectModalDI from '@atlassian/jira-project-permanent-delete-modal/src/async.tsx';
import type { Props as AppProps } from '@atlassian/jira-project-permanent-delete-modal/src/ui/types.tsx';
import type { ModalProps } from '../../types.tsx';

export type HardDeleteProjectModalOptions = {
	projectId: number;
	projectName: string;
	projectType: ProjectType;
	isProjectSimplified: boolean;
};

export type Props = AppProps & ModalProps;

const AsyncHardDeleteProject = ({
	onClose,
	projectName,
	projectId,
	projectType,
	isProjectSimplified,
	// @ts-expect-error - TS2339 - Property 'ContextualAnalyticsData' does not exist on type 'Props'.
	ContextualAnalyticsData = ContextualAnalyticsDataDI,
	// @ts-expect-error - TS2339 - Property 'AsyncHardDeleteProjectModal' does not exist on type 'Props'.
	AsyncHardDeleteProjectModal = AsyncHardDeleteProjectModalDI,
}: Props) => {
	const onProjectActionSuccess = (): void => {
		onClose();

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.location.replace('/jira/your-work');
	};

	return (
		<ContextualAnalyticsData sourceName="EditProjectDetails" sourceType={SCREEN}>
			<AsyncHardDeleteProjectModal
				onClose={onClose}
				projectName={projectName}
				projectType={projectType}
				projectId={projectId}
				isProjectSimplified={isProjectSimplified}
				onProjectDeleteSuccess={onProjectActionSuccess}
				onProjectDeleteFailure={noop}
			/>
		</ContextualAnalyticsData>
	);
};

export default AsyncHardDeleteProject;
